<template>
  <div>
    <div>
      <button v-bind:class="{ choose_image_shape_active: ChooseImageShapeActive }" type='button' @click="ShowChooserStarMap" class="btn btn-chooser-star-map">
        <v-icon class='v-ion-abn' name='star'></v-icon> Start Map
      </button>
    </div>

    <div v-if="this.BoxcontentMessageError" class="message-error-left-group">
      <div>{{contentMessageError}}</div>
    </div>

    <modal
      :name="modalName"
      :adaptive="true"
      height="auto"
      width="1000"
      @ok="onStarMap"
      @cancel="handleCancel"
      :clickToClose="false"
      :reset="true"
      class='Modal_star_map_box'
    >
      <div @click="hideModal" class="Abn-modal-close">&#10005;</div>

      <div class="dev_box_sky_star">
        <div v-if='TransparentBackground == true' class="Abn_polar_star_fake" style='background: rgb(0 0 0 / 0%)'></div>
        <div v-else class="Abn_polar_star_fake" :style="{ 'background-color': background_fake_star}"></div>
        <div id="Abn_starmap_dev" style='width: 100%; height: 100%'></div>
      </div>

      <div class='Abn-modal-crop'>

        <div class="modal-wrapper" v-bind:class='{transparentbackground: TransparentBackground}'>
          <div class='box_star_map'>
            <div v-if='TransparentBackground == true' id="bg-star-fake" class="Abn_polar_star_fake" style='background: rgb(0 0 0 / 0%)'></div>
            <div v-else id="bg-star-fake" class="Abn_polar_star_fake" :style="{ 'background-color': background_fake_star}"></div>
            <div v-if='OnStarSkyDefauld' class="Abn-Image-shape-url-47">
              <img style='width: 100%; height: 100%'  :src="UrlStarSkyDefauld">
            </div>

            <div id="Abn_starmap" style='width: 100%; height: 100%'></div>
            <div v-if='this.typeskystar == "stereo" ' class='Abn-Image-shape-url-box'>
              <img class="Abn-Image-shape-url" :src="UrlImageShape">
            </div>

            <div v-if='this.typeskystar == "polar" ' class='Abn-Image-shape-url-box'>
              <img class="Abn-Image-shape-url" src="https://d111oohu250q1p.cloudfront.net/c139d4b0-8e04-11ec-8a9d-267b280bfd39__polar_png.png">
            </div>
          </div>
        </div>

        <div class='Abn-box-group-star-item'>
        <div class='Abn-box-select-item'>
          <h5>WHERE DO YOU WANT TO SEE THE SKY FROM?</h5>
          <gmap-autocomplete 
            placeholder="Enter the location" class="Abn-form-search-map"
            @place_changed="ChangeLocal"
            :options="{fields: ['geometry', 'formatted_address', 'address_components']}"
          >
          </gmap-autocomplete>
        </div>

        <div class='Abn-box-select-item'>
          <h5>WHEN WAS YOUR SPECIAL OCCASION?</h5>
          <div class="group_picker_date_time_star_map">
            <date-picker class='abn_date_picker' v-model='starDate' type='date' placeholder='Select date' default-value='' valueType='MMMM DD, YYYY' ></date-picker>
            <date-picker class='abn_date_picker abn_time_picker abn_time_picker_mobile' v-model="starTime" type='time' placeholder='Select time' default-value='' valueType='HH:mm:ss'></date-picker>
            <button class='btn btn-show-time' @click='OnShowTime'>Show Time</button>
            <date-picker v-if='showTime' class='abn_date_picker abn_time_picker abn_time_picker_none_mobile' v-model="starTime" type='time' placeholder='Select time' default-value='' valueType='HH:mm:ss'></date-picker>
          </div>
        </div>

        <div class='Abn-box-select-item' v-if='transparentbackground == false'>
          <h5>BACKGROUND COLOR:</h5>
          <div class='box_show_theme_optons'>
            <div v-for="(value, name) in backgroundcolors">
              <input class='Abn_input_background_color_star' :id='name' :value='value' name='background_color' type='radio' v-model='background_fake_star' />
              <label :for='name'>
                <div class='Box_item_background_color_start' v-bind:style='{background: value}'></div>
              </label>
            </div>
          </div>
        </div>

        <div class='Abn-box-select-item'>
          <h5>THEME OPTIONS:</h5>
          <div class='box_show_theme_optons option-checkbox-start'>
            <div>
              <input v-model='valGrid' type='checkbox' id='show_grid' />
              <label for='show_grid'>SHOW GRID</label>
            </div>

            <div>
              <input v-model='valConstellations' type='checkbox' id='show_constellations'/>
              <label for='show_constellations'>SHOW CONSTELLATIONS</label>
            </div>
          </div>

        </div>

        <div class="Abn-modal-footer">
          <div class="Abn-modal-footer-div">
            <button type="button" @click="hideModal" class="btn Abn-btn-cancel">Cancel</button>
            <button type="button" class="btn Abn-btn-apply" @click="ButtonApply">Apply</button>
          </div>
        </div>

      </div>

      </div>


    </modal>
  </div>
</template>

<script>
import jQuery from 'jquery'
import axios from 'axios'
import DatePicker from 'vue2-datepicker';
import html2canvas from 'html2canvas';
import 'vue2-datepicker/index.css';
import { ASSET_URL, URL_API_IMAGE_SHAPE, URL_API_FILL_IMAGES_SHAPE } from '@/config.js'
import { mapGetters, mapMutations } from 'vuex'
import {get} from 'lodash'
import { loadVirtualSky, isVirtualSkyReady } from '@/helper/virtualSky'
export default {
  props: {
    context: {
      type: Object,
      required: true
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    shapes: {
      type: String,
      default() {
        return null
      }
    },
    name: {
      type: String,
      default(){
        return null
      }
    },
    typeskystar: {
      type: String,
      default(){
        return 'stereo';
      }
    },
    skystaridparent: {
      type: String,
      default(){
        return null
      }
    },
    transparentbackground: {
      type: Boolean,
      default(){
        return false
      }
    },
    starcolor: {
      type: String,
      default(){
        return "#ffffff"
      }
    },
    backgroundcolors: {
      type: Array,
      default(){
        return ["#000000"]
      }
    },
    rectangularType: {
      type: String,
      default(){
        return "transverse"
      }
    },
    scaleStars: {
      type: Number,
      default(){
        return 1
      }
    },
    scaleConstellations: {
      type: Number,
      default(){
        return 0.7
      }
    },
    scaleGrid: {
      type: Number,
      default(){
        return 0.5
      }
    }
  },
  data() {
    return {
      messageLoading: false,
      starLongitude: -95.712891,
      starLatitude: 37.09024,
      starDate: 'January 01, 2022',
      starTime: '00:00:00',
      showTime: false,
      HideIframe: false,
      HideStarmap: true,
      valGrid: false,
      valConstellations: true,
      background_fake_star: '',
      UrlImageShape: null,
      ChooseImageShapeActive: false,
      BoxcontentMessageError: false,
      contentMessageError: '',
      valueLocation: '',
      UrlStarSkyDefauld: null,
      OnStarSkyDefauld: true,
      TransparentBackground: false,
      typeSkyStarName: "polar"
    }
  },
  created() {
    this.UrlImageShape = ASSET_URL + '/' + this.shapes;
    if(this.typeskystar == 'polar'){
      this.typeSkyStarName = "polar"
    }else{
      this.typeSkyStarName = "stereo"
    }

    this.TransparentBackground = this.transparentbackground
    // Start fetching the star map scripts as soon as this layer exists, so
    // they're usually in by the time the customer opens the chooser.
    loadVirtualSky().catch(err => console.error(err))
  },
  mounted() {

  },
  components: {
    DatePicker
  },
  computed: {
    modalName() {
      return `star_map-${this.uniqueID(10)}`
    },
    localStorageName(){
      return this.context.name + '_' + this.product().id;
    }
  },
  watch: {
    starLongitude(){
      this.loadingStar()
    },
    starLatitude(){
      this.loadingStar()
    },
    starDate(){
      this.loadingStar()
    },
    starTime(){
      this.loadingStar()
    },
    valGrid(){
      this.loadingStar()
    },
    valConstellations(){
      this.loadingStar()
    },
    background_fake_star(){
      if(this.background_fake_star != "rgb(0 0 0 / 0%)"){
        this.TransparentBackground = false
      }else {
        this.TransparentBackground = true
      }
      this.loadingStar()
    }
  },
  methods: {
    ...mapGetters([
      'product',
      'platform',
      'getCartData',
      'isSaveLocalstorage'
    ]),
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    // Retry path after a failed draw. The scripts themselves are (re)loaded
    // by loadingStar via loadVirtualSky — appending them again here as two
    // async tags could race exactly like the original page-start load.
    loadingScriptVirtualSky(){
      this.OnStarSkyDefauld = true
      this.$modal.show(this.modalName)

      this.valueLocation = ''
      setTimeout(() => {
        this.loadingStar();
      }, 100);
    },
    ShowChooserStarMap(e){
      e.preventDefault()

      this.OnStarSkyDefauld = true

      this.$modal.show(this.modalName)

      this.valueLocation = ''
      setTimeout(() => {
        this.loadingStar();
      }, 100);
    },
    loadingStarUptoSize(){
      this.OnStarSkyDefauld = false
      const OnThis = this;
      var ratio = 2;
      const box_star_map = document.querySelector('.box_star_map');
      if(box_star_map){
        var width_box_star_map = box_star_map.offsetWidth;
        ratio = 1000 / width_box_star_map;
      }
      try{
        // Gọi thẳng, KHÔNG qua S(document).ready: khi trang chưa tải xong hẳn
        // (readyState "interactive", ảnh/iframe còn đang tải) stuquery chuyển hàm
        // thành chuỗi rồi setTimeout("S(document).ready(" + fn + ")") → hàm mất
        // closure (OnThis) → "e is not defined", lần vẽ đó bị bỏ. Component đã
        // mount nên DOM chắc chắn sẵn sàng; khi trang đã "complete" ready() cũng
        // gọi hàm ngay như thế này.
        (function () {
          var planetarium = S.virtualsky({
            id: "Abn_starmap_dev",
            projection: OnThis.typeSkyStarName,
            latitude: OnThis.starLatitude,
            longitude: OnThis.starLongitude,
            gradient: false,
            cardinalpoints:false,
            constellations: OnThis.valConstellations,
            showplanets:false,
            magnitude: 10000,
            live:false,
            az: 180,
            gridlines_eq: OnThis.valGrid,
            ground: true,
            contextmenu:false,
            showdate:false,
            showposition:false,
            clock: new Date(OnThis.starDate + ' ' + OnThis.starTime),
            transparent: true,
            galaxywidth: 100,
            keyboard: false,
            gridstep: 15,
            mouse: false,
            scalestars: OnThis.scaleStars * ratio,
            gridlineswidth: OnThis.scaleGrid * ratio,
            constellationwidth: OnThis.scaleConstellations * ratio
          });

          if(OnThis.TransparentBackground){
            OnThis.background_fake_star = "rgb(0 0 0 / 0%)"
          }else {
            if(OnThis.background_fake_star == ''){
              OnThis.background_fake_star = OnThis.backgroundcolors[0]
            }
          }

          planetarium.col.eq = OnThis.starcolor + 'c7'
          planetarium.col.stars = OnThis.starcolor
          planetarium.col.constellation = OnThis.starcolor + 'c7'
          planetarium.col.black = OnThis.background_fake_star

          S('.Abn_starmap_btn_help.virtualskybutton').css({
            "display": "none !important"
          });

          S('.Abn_starmap_credit').css({
            "display": "none !important"
          });

          S('.Abn_starmap_clock').css({
            "display": "none !important"
          });

          S('.Abn_starmap_position').css({
            "display": "none !important"
          });
        })();
      }catch(error){
        this.$modal.hide(this.modalName);
        setTimeout(() => {
          this.loadingScriptVirtualSky();
        }, 500);
      }
    },
    loadingStar(){
      // stuquery/virtualsky load on demand (helper/virtualSky.js); draw once
      // they're in instead of failing on a missing global `S`.
      if (!isVirtualSkyReady()) {
        loadVirtualSky()
          .then(() => this.loadingStar())
          .catch(err => console.error(err))
        return
      }
      this.loadingStarUptoSize();
      this.OnStarSkyDefauld = false

      const OnThis = this;
      try{
        // Gọi thẳng, KHÔNG qua S(document).ready: khi trang chưa tải xong hẳn
        // (readyState "interactive", ảnh/iframe còn đang tải) stuquery chuyển hàm
        // thành chuỗi rồi setTimeout("S(document).ready(" + fn + ")") → hàm mất
        // closure (OnThis) → "e is not defined", lần vẽ đó bị bỏ. Component đã
        // mount nên DOM chắc chắn sẵn sàng; khi trang đã "complete" ready() cũng
        // gọi hàm ngay như thế này.
        (function () {
          var planetarium = S.virtualsky({
            id: "Abn_starmap",
            projection: OnThis.typeSkyStarName,
            latitude: OnThis.starLatitude,
            longitude: OnThis.starLongitude,
            gradient: false,
            cardinalpoints:false,
            constellations: OnThis.valConstellations,
            showplanets:false,
            magnitude: 10000,
            live:false,
            az:180,
            gridlines_eq: OnThis.valGrid,
            ground: true,
            contextmenu:false,
            showdate:false,
            showposition:false,
            clock: new Date(OnThis.starDate + ' ' + OnThis.starTime),
            transparent: true,
            galaxywidth: 100,
            keyboard: false,
            gridstep: 15,
            mouse: false,
            scalestars: OnThis.scaleStars,
            gridlineswidth: OnThis.scaleGrid,
            constellationwidth: OnThis.scaleConstellations
          });

          if(OnThis.TransparentBackground){
            OnThis.background_fake_star = "rgb(0 0 0 / 0%)"
          }else {
              if(OnThis.background_fake_star == ''){
                OnThis.background_fake_star = OnThis.backgroundcolors[0]
              }
          }

          planetarium.col.eq = OnThis.starcolor + 'c7'
          planetarium.col.stars = OnThis.starcolor
          planetarium.col.constellation = OnThis.starcolor + 'c7'
          planetarium.col.black = OnThis.background_fake_star

          S('.Abn_starmap_btn_help.virtualskybutton').css({
            "display": "none !important"
          });

          S('.Abn_starmap_credit').css({
            "display": "none !important"
          });

          S('.Abn_starmap_clock').css({
            "display": "none !important"
          });

          S('.Abn_starmap_position').css({
            "display": "none !important"
          });
        })();
      }catch(error){
        this.$modal.hide(this.modalName);
        setTimeout(() => {
          this.loadingScriptVirtualSky();
        }, 500);
      }
    },
    async onStarMap() {
      this.setLoadingForm(true)
      this.setLoadingForm(false)
    },
    OnShowTime(e){
      e.preventDefault()
      this.showTime = !this.showTime
    },
    ChangeLocal(loc){
      this.starLongitude = loc.geometry.location.lng()
      this.starLatitude = loc.geometry.location.lat()

      this.valueLocation = loc.formatted_address
    },
    handleCancel() {
      if (!(this.value && this.value.base64)) {
        this.file = null
      }
      this.showCropper = false
    },
    renderCoordinatesMap(lat, lng){
      let iconLat = Number(lat) < 0 ? 'S' : 'N';
      let iconLng = Number(lng) < 0 ? 'W' : 'E';
      return Math.abs(lat).toFixed(4) + '° ' + iconLat + ', ' + Math.abs(lng).toFixed(4)  + '° ' + iconLng;
    },
    async ButtonApply(e) {
      e.preventDefault()

      if (this.valueLocation == ''){
        this.contentMessageError = 'Please select the address!';
        this.BoxcontentMessageError = true;

        const ThisOn = this

        setTimeout(function() {
          ThisOn.BoxcontentMessageError = false
        }, 2000)
      }else {
      this.setLoadingForm(true)

      const OnThis = this

      html2canvas(document.querySelector('.dev_box_sky_star'), {backgroundColor:null}).then(async function(canvas) {
        var img = canvas.toDataURL("image/png")

        OnThis.setLoadingForm(true)

        const UploadFile = await OnThis.upload(img);
        if(UploadFile.status){
          var UrlImageShaoe
          if(OnThis.typeskystar == 'polar'){
            UrlImageShaoe = 'https://d111oohu250q1p.cloudfront.net/c139d4b0-8e04-11ec-8a9d-267b280bfd39__polar_png.png';
          }else {
            UrlImageShaoe = OnThis.UrlImageShape
          }
          var ImagestartRender
          if(OnThis.OnStarSkyDefauld){
            ImagestartRender = OnThis.UrlStarSkyDefauld
          }else {
            ImagestartRender = ASSET_URL + '/' + UploadFile.key
          }
          OnThis.setCartDataByKey({
            key: OnThis.localStorageName,
            name: OnThis.context.label,
            value: ImagestartRender
          });
          try{
            const ImageShapeRawResponse = await fetch(URL_API_IMAGE_SHAPE, {
              method: 'post',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                urlShape: UrlImageShaoe,
                urlImages: ImagestartRender
              })
            });
            const contentCanvas = await ImageShapeRawResponse.json();

            const file = {
              id: OnThis.context.name,
              key: contentCanvas.key
            }
            OnThis.setIsSaveLocalstorage(true);
            OnThis.context.model = file
            // Text Address
            if(OnThis.skystaridparent != null){
              const EmitData = {
                address: OnThis.valueLocation,
                id: OnThis.skystaridparent,
                date: OnThis.starDate,
                Coordinates: OnThis.renderCoordinatesMap(OnThis.starLatitude, OnThis.starLongitude)
              }
              OnThis.$emit('ChangeApplySky', EmitData)
            }
            OnThis.ChooseImageShapeActive = true

            OnThis.$modal.hide(OnThis.modalName)
          }catch(err){
            OnThis.setLoadingForm(false);
            OnThis.setMessageError(true)
          }
        }
        OnThis.setLoadingForm(false)
      });

      }
    },
    hideModal(e) {
      e.preventDefault()
      this.$modal.hide(this.modalName)
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const put = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if(put.status === 200){
        return {
          status: true,
          key: signedUrl.key
        }
      }else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style>

.dev_box_sky_star{
  width: 1000px;
  height: 1000px;
  position: fixed !important;
  top: -10000px;
  right: 0;
  left: 0;
  background: #00000015;
  pointer-events: none !important;
}
#Abn_starmap a{
  display: none;
}

#Abn_starmap{
  /*transform: rotate(0deg) scale(1.4) skew(1deg) translate(0px);*/
  /*-webkit-transform: rotate(0deg) scale(1.4) skew(1deg) translate(0px);*/
  /*-moz-transform: rotate(0deg) scale(1.4) skew(1deg) translate(0px);*/
  /*-o-transform: rotate(0deg) scale(1.4) skew(1deg) translate(0px);*/
  /*-ms-transform: rotate(0deg) scale(1.4) skew(1deg) translate(0px);*/
}

.starmap_btn_help.virtualskybutton {
  display: none;
}

.Modal_star_map_box > div{
  /*overflow: auto;*/
}


.Modal_star_map_box > div::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.Modal_star_map_box > div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

@media only screen and (max-width: 739px){
  .Modal_star_map_box > div{
    padding: 0px 10px;
  }

  .Abn-box-select-item > h5 {
    font-size: 16px;
  }

  .Modal_star_map_box .vm--modal{
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 0px !important;
    z-index: 999999;
    overflow: hidden !important;
  }

}

.Abn_starmap_credit {
    display: none !important;
}


.Abn_starmap_btn_help.virtualskybutton {
    display: none !important;
}

/* May 18 edit */
.pac-container, .mx-datepicker-main.mx-datepicker-popup {
    z-index: 9999999 !important;
}

</style>

<style scoped>

.message-text-loading {
  color: #e1e1e1;
  font-weight: 500;
  text-shadow: 0px 0px 5px #0000007d;
}

.Abn-modal-footer {
  position: sticky;
  bottom: 0px;
  left: 0;
  right: 0;
  background: #ffffff;
}

/* May 18 edit */
.Modal_star_map_box {
    z-index: 999999 !important;
}
.Abn-box-select-item > h5 {
  font-size: 16px;
  font-weight: 700;
}

.abn_time_picker_mobile{
  display: none;
}

.copper-wrapper {
  display: grid;
  grid-template-columns: auto 120px;
}
.modal-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 100%;
  /* grid-template-rows: auto 40px; */
}
.modal-wrapper .cropper-wrapper {
  overflow: hidden;
  margin-bottom: 10px;
}

.Abn-modal-crop{
  overflow: auto ;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;
  display: flex;
  padding: 10px 15px ;
}

.Box_item_background_color_start.Box_item_background_color_none > div {
  width: 30px;
  height: 30px;
  border: 1px solid black;
  color: red;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 47px;
  overflow: hidden;
  font-weight: 100;
}

.Box_item_background_color_start.Box_item_background_color_none {
  padding: 0.5px;
}
.Abn-modal-crop > div{
  width: 50%;
}

.Abn-modal-footer{
  overflow: auto ;
  width: 800px;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 2px;
  padding: 5px;

}

.Abn-modal-footer-div {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}




.modal-wrapper .cropper-wrapper::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.modal-wrapper .cropper-wrapper::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.modal-wrapper{
  position: relative;
  margin-top: 7px ;
  width: 100%;
  border-radius: 4px;
}

.modal-wrapper:after {
  content: "";
  display: block;
  padding-bottom: 100%;
}

.Modal_star_map_box{
  overflow: auto;
}


.box_star_map {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.Abn-form-search-map{
  width: 100%;
  outline: none;
  padding: 7px;
  border: 2px solid #66666a;
  border-radius: 5px;
  transition: 0.7s;
}
.Abn-form-search-map:focus{
  border: 2px solid  #9e0000;
}

.abn_date_picker {
  width: 100%;
  margin: 7px auto;
}

.abn_date_picker .mx-input{
  height: 40px;
  border: 2px solid darkblue !important;
}
.btn-show-time{
  background: #077fb8;
  border: 1px solid darkgreen;
  color: #ffffff;
}

.Abn-box-select-item {
  margin-top: 10px;
  margin-bottom: 20px;
}

.box_show_theme_optons {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
}

.box_show_theme_optons > div {
  margin-right: 30px;
  display: flex;
  align-items: center;
}

.box_show_theme_optons > div > input{
  margin-right: 5px;
}

.box_show_theme_optons > div label{
  line-height: 1;
}

.box_star_map{
  /*pointer-events: none;*/
  /*box-shadow: 0px 0px 2px #585a5b;*/
  /*border-radius: 7px;*/
  overflow: hidden;
}

.hide_starmap{
  display: none;
}
.Abn_polar_star_fake{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}

.Box_item_background_color_start {
  padding: 15px;
  border-radius: 5px;
}

.Abn_input_background_color_star {
  display: none;
}

.box_show_theme_optons input[type=radio]:checked ~ label > div{
  border: 2px solid white;
}

.box_show_theme_optons input[type=radio]:checked ~ label {
  border: 2px solid #dc3545 !important;
  border-radius: 5px;
}

.message-loading-group {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  right: 0 !important;
  background: #5b5b5b87 !important;
  z-index: 9999999999999999 !important;
}

.message-loading-div {
  margin: 0 auto !important;
  width: 100% !important;
  text-align: center !important;
  position: absolute !important;
  top: 50% !important;
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}


.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.Abn-Image-shape-url-box{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 999999;
}

.Abn-Image-shape-url{
  width: 100%;
  height: 100%;
  pointer-events: none;
  filter: invert(100%);
}

.modal-wrapper.transparentbackground {
  background: #212529;
}


.choose_image_shape_active {
  background: #26bf31 !important;
  border: 1px solid #26bf31 !important;
  animation-name: animation_button_active;
  animation-duration: 2s;
}

@keyframes choose_image_shape_active {
  from {opacity: 0.1;}
  to {opacity: 1;}
}

.v-ion-abn{
  width: 16px;
  padding: 0;
  margin: 0;
}

.message-error-left-group {
  position: fixed !important;
  top: 10px !important;
  right: 10px !important;
  background: #0dcaf0 !important;
  padding: 5px 25px !important;
  border-radius: 10px 0px 10px 10px !important;

  z-index: 9999999999999999 !important;
}

.message-error-left-group {
  color: white !important;
  font-weight: 500 !important;
}

.Abn-box-group-star-item{
  padding: 0 10px;
}

.Abn-modal-close {
  background: #6e6e6f;
  width: 40px;
  height: 40px;
  text-align: center;
  color: white;
  font-weight: 900;
  position: absolute;
  right: 0;
  font-size: 18px;
  display: flex;
  top: 0px;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  z-index: 9999999999999999999999;
}

.box_show_theme_optons {
  overflow: auto;
}

.box_show_theme_optons::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #F5F5F5;
}

.box_show_theme_optons::-webkit-scrollbar-thumb {
  background-color: #00254d;
  height: 2px;
}

@media only screen and (max-width: 739px){
  .Abn-modal-crop > div{
    width: 100%;
    height: auto;
  }

  .modal-wrapper{
    width: 42vh !important;
    height: 42vh !important;
  }

  .Abn-modal-crop {
    overflow: auto;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    margin-top: 2px;
    padding: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 10px 15px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    overflow: hidden !important;
}

  .option-checkbox-start{
    flex-direction: column;
  }

  .option-checkbox-start > div label{
    font-size: 15px;
    margin-top: 5px;
    font-weight: 600;
  }
  .option-checkbox-start > div{
    width: 100% !important;
    font-size: 14px;
  }

  .Abn-box-group-star-item{
    height: 45vh !important;
    overflow: auto !important;
    /*padding-bottom: 40px !important;*/
  }

  .Abn-modal-footer {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
  }
  .box_show_theme_optons{
    overflow: hidden;
  }

  .abn_time_picker_none_mobile{
    display: none;
  }

  .Abn-box-select-item{
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .Abn-box-select-item > h5{
    font-size: 13px !important;
    margin: 0px !important;
    margin-bottom: 5px !important;
  }

  .box_show_theme_optons.option-checkbox-start {
    display: flex;
    flex-direction: row !important;
  }

  .box_show_theme_optons.option-checkbox-start > div{
    margin-left: 0px !important;
    margin-right: 10px !important;
    width: fit-content !important;
  }

  .abn_date_picker{
    margin-top: 0px !important;
  }

  .option-checkbox-start > div label{
    font-weight: 100;
    font-size: 13px;
  }
  .abn_time_picker{
    margin-left: 3px;
  }
  .abn_time_picker, .abn_date_picker{
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .btn-show-time{
    display: none;
  }
  .group_picker_date_time_star_map{
    display: flex;
    align-items: center;
  }
  .abn_time_picker_mobile{
    display: block;
  }

  .box_show_theme_optons > div{
    margin-right: 15px;
  }
}

.Abn-Image-shape-url-47 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999999;
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageStarMap.vue